export default {
  A3: "A3",
  A4: "A4"
};
